const negotiateAwbReference = require('./resultModel/negotiateAwbReference');
const formatLoadingMetres = require('./resultModel/formatLoadingMetres');
const formatVolume = require('./resultModel/formatVolume');
const formatWeight = require('./resultModel/formatWeight');
const getDocuments = require('./resultModel/getDocuments');
const getEvents = require('./resultModel/getEvents');
const getPackageEvents = require('./resultModel/getPackageEvents');
const getParty = require('./resultModel/getParty');
const getPod = require('./resultModel/getPod');
const getPackages = require('./resultModel/getPackages');
const moment = require('moment');
const { formatDateTime, queryParser  } = require('gui');

module.exports = function resultModel(dto) {

    const transporterCode = queryParser.get('id') || 'tim';
    
    const c = {};
    c.waybillNumber = dto.WayBillNo;
    c.freeText = dto.FreeText;
    c.weight = formatWeight(dto.Weight);
    c.etd = createDateString(dto.Etd);
    c.eta = createDateString(dto.Eta);
    c.orderId = dto.OrderId;
    c.numberOfPallets = dto.NumberOfPallets;
    c.volume = formatVolume(dto.Volume);
    c.sendersReference = dto.SendersReference;
    c.poReference = dto.PoReference;
    c.containerNumberReference = dto.ContainerNumber;
    c.goodsType = dto.GoodsType;
    c.numberOfUnits = dto.NumberOfUnits;
    c.loadingMetres = formatLoadingMetres(dto.LoadingMetres);
    c.customersReference = dto.CustomersReference;
    c.events = getEvents(dto);
    c.packages = getPackages(dto.Packages);
    c.packageEvents = getPackageEvents(dto.PackageEvents);
    c.proofOfDeparture = getPod(dto.ProofOfDeparture);
    c.proofOfDelivery = getPod(dto.ProofOfDelivery);

    c.consignor = getParty(dto.Consignor);
    c.consignee = getParty(dto.Consignee);
    c.deliveryParty = getParty(dto.DeliveryParty);
    c.despatchParty = getParty(dto.DespatchParty);

    let arrivalAtd = createTimeString(dto.ArrivalAtd);
    let arrivalAta = createTimeString(dto.ArrivalAta);
    let waitingMinutesAtd = dto.ArrivalAtd && (dto.ArrivalAtd - dto.Atd) / (1000 * 60);
    let waitingMinutesAta = dto.ArrivalAta && (dto.ArrivalAta - dto.Ata) / (1000 * 60);
    c.arrivalAtdText = dto.ArrivalAtd && `${waitingMinutesAtd} min ${arrivalAtd}`;
    c.arrivalAtaText = dto.ArrivalAta && `${waitingMinutesAta} min ${arrivalAta}`;

    c.documents = getDocuments(dto.ScannedDocuments);

    negotiateAwbReference(c, dto.Awb);
    c.hwbReference = dto.Hwb;

    c.subscribeChange = function() {};
    c.unsubscribeChange = function() {};

    if (transporterCode === 'haugland') {
        c.etd += ' ' + createTimeString(dto.Etd);
        c.eta += ' ' + createTimeString(dto.Eta);
    }

    return c;
};

function createTimeString(ticks) {
    if(!ticks)
        return '';
    return formatDateTime(moment(ticks), 'HH:mm');
}

function createDateString(ticks) {
    if(!ticks)
        return '';
    return formatDateTime(moment(ticks), 'L');
}
